module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "sidebarTextInput",
    staticClass: "sidebar-text-input"
  }, _vm._l((_vm.data), function(input, index) {
    return _c('div', {
      key: input.key,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-12"
    }, [_c('erco-text-input', {
      staticClass: "_input",
      attrs: {
        "label": input.label,
        "text": input.text,
        "inputType": "auto",
        "resetable": true,
        "charlength": input.charlength
      },
      on: {
        "input": function($event) {
          _vm.handleInput(index, $event)
        },
        "reset": function($event) {
          _vm.handleReset(index)
        }
      }
    })], 1)])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d425ebc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/ErcoSidebar/TextInput.vue
// module id = 616
// module chunks = 0